import React, {memo} from 'react';
import PropTypes from 'prop-types';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-react';

const Editor = ({value, onChange}) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onChange={(event, editor) => {
        onChange({target: {value: editor.getData()}});
      }}
    />
  );
};

export default memo(Editor);

Editor.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func
};